import css from './style.module.css';

export default function SetupTabPanel({ objKey, setKey, tabName, activeTab, setActiveTab, setEditIndex }) {
    return (
        <li className={`${css.tabItem} nav-item flex-fill`}>
            <button
                className={`${css.tabButton} nav-link w-100 text-center ${activeTab === tabName ? css.active : ''}`}
                onClick={() => {
                    setActiveTab(tabName);
                    setKey(objKey);
                    setEditIndex(null)
                }}
            >
                <span className="d-block d-sm-inline">{tabName}</span>
            </button>
        </li>
    );
}